export const landingV2Content = {
  seo: {
    title: 'Doocars: The smartest way to buy your next car',
    description: 'Every UK car listing scored daily against your needs. Stop scrolling. Start knowing.',
    canonical: '/',
    ogImage: '/og-image.png',
  },
  header: {
    nav: [
      { title: 'How it works', target: '#how-it-works' },
      { title: 'Score Breakdown', target: '#score-breakdown' },
      { title: 'Pricing', target: '/pricing', requiresPaywall: true },
      { title: 'Testimonials', target: '#testimonials' },
      { title: 'FAQ', target: '#faq' },
    ],
    cta: { title: 'Get Started', intent: undefined },
  },
  hero: {
    titleLine1: 'The smartest way',
    titleLine2: 'to buy your next car',
    subtitle: "We analyse every UK listing across every platform.\nAI matches them to exactly what you're looking for.",
    photo: { alt: 'A buyer with their car', srcSet: null },
    cta: { title: 'Get Started', intent: undefined },
    reassurance: 'Free to start. No card needed.',
  },
  oneFeed: {
    title: 'Every market. Every dealer. One feed.',
    subtitle: 'We connect every major listing source and score them daily, so you only see what fits.',
    sources: ['AutoTrader', 'CarGurus', 'CarWow', 'eBay', 'Facebook Marketplace'],
  },
  scoreBreakdown: {
    title: 'Every car explained in plain English.',
    subtitle: 'The price tag is just the beginning.',
    rows: [],
  },
  howItWorks: {
    title: 'Simple by design. Powerful underneath.',
    subtitle: '',
    steps: [
      { title: 'Tell us your model or let us find it', body: 'Track a specific model, or answer 20 questions to discover the right car for how you actually live and drive.' },
      { title: 'We scan everything', body: 'Every day, we pull new listings from AutoTrader, CarGurus, CarWow, eBay, Facebook Marketplace and dozens more. Every car scored against your brief. Every morning.' },
      { title: 'You get the best', body: 'Your curated feed lands daily. Each car labelled Buy Now, Watch, or Hold, with AI insights, price vs. market, and your true running costs. No noise. Just your matches.' },
    ],
  },
  comparison: {
    title: 'Built for buyers, Not for dealers.',
    subtitle: '',
    columns: [],
    rows: [],
  },
  testimonials: {
    title: 'Real results from real buyers.',
    subtitle: 'Real buyers who let Doocars watch the market for them.',
    items: [],
  },
  faq: {
    title: "Questions? We've Got Answers",
    subtitle: 'Everything you need to know about how Doocars works.',
    questions: [
      {
        question: 'How accurate are your recommendations?',
        answer:
          'Our system has been tested with real users who confirmed the recommendations matched their needs perfectly. We continuously improve based on real-world feedback.',
      },
      {
        question: 'Do you only show certain brands?',
        answer:
          'No. We scan every UK car platform and brand. Your feed is filtered only by what fits your brief.',
      },
      {
        question: "What if I don't like the recommendations?",
        answer:
          'You can adjust your brief at any time. The feed re-scores instantly and updates the next morning.',
      },
      {
        question: 'Is this really free?',
        answer:
          'Yes, getting started is completely free. Track up to 5 models, get daily matches, no card needed.',
      },
      {
        question: 'Do you cover all of Europe?',
        answer:
          'Not yet. Doocars is UK-only at launch. We plan to expand to other European markets after we are settled here.',
      },
    ],
  },
  finalCTA: {
    title: 'Stop searching. Start knowing.',
    subtitle: '',
    cta: { title: 'Get Started', intent: undefined },
    reassurance: 'Free to start. No card needed.',
  },
  footer: {
    links: [
      { title: 'Privacy policy', target: '/privacy-policy' },
      { title: 'Terms & Conditions', target: '/terms-and-conditions' },
      { title: 'Contact us', target: undefined },
    ],
    legal: 'Doocars · Unit 166466, PO Box 7169, Poole, BH15 9EL · © 2026 Doocars. All rights reserved.',
  },
};

export default landingV2Content;
